import {createRouter, createWebHistory} from 'vue-router'

var Console = () => import('./Console.vue')

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect: '/Welcome'
        },
        {
            path: '/User/RoleAuthority/List',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/User/RoleAuthority/List.vue'),
                }
            ]
        },
        {
            path: '/Login',
            component: () => import('./models/Login.vue'),
        },
        {
            path: '/Welcome',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Welcome.vue'),
                }
            ]
        },
        {
            path: '/User/Center/List',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/User/Center/List.vue'),
                }
            ]
        },
        {
            path: '/Wallet/Info',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Wallet/Info.vue'),
                }
            ]
        },
        {
            path: '/Extension/Info',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Wallet/ExtensionInfo.vue'),
                }
            ]
        },
        {
            path: '/Consumption/Info',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Wallet/ConsumptionInfo.vue'),
                }
            ]
        },
        {
            path: '/City/City/List',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/City/List.vue'),
                }
            ]
        },
        {
            path: '/City/City/Form',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/City/Form.vue'),
                }
            ]
        },
        {
            path: '/Address/Address/List',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Address/List.vue'),
                }
            ]
        },
        {
            path: '/Address/Address/Form',
            component: Console,
            children: [
                {
                    path: '',
                    component: () => import('./models/Address/Form.vue'),
                }
            ]
        },
        // 下面为自动生成
        {
            path: '/PlatformInformation/PlatformInformation',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/PlatformInformation/PlatformInformation/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/PlatformInformation/PlatformInformation/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/PlatformInformation/PlatformInformation/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/EntrepreneurshipPosition',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/EntrepreneurshipPosition/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/EntrepreneurshipPosition/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/EntrepreneurshipPosition/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/Entrepreneurship',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/Entrepreneurship/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/Entrepreneurship/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/Entrepreneurship/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/ProjectPosition',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/ProjectPosition/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/ProjectPosition/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/ProjectPosition/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/Project',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/Project/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/Project/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/Project/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/Pay',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/Pay/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/Pay/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/Pay/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/CompanyPosition',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/CompanyPosition/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/CompanyPosition/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/CompanyPosition/Info.vue'),
                }
            ]
        },
        {
            path: '/Agent/Agent',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Agent/Agent/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Agent/Agent/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Agent/Agent/Info.vue'),
                }
            ]
        },
        {
            path: '/CompanyInformation/CompanyInformation',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/CompanyInformation/CompanyInformation/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/CompanyInformation/CompanyInformation/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/CompanyInformation/CompanyInformation/Info.vue'),
                }
            ]
        },
        {
            path: '/User/Logs',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/User/Logs/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/User/Logs/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/User/Logs/Info.vue'),
                }
            ]
        },
        {
            path: '/User/Role',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/User/Role/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/User/Role/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/User/Role/Info.vue'),
                }
            ]
        },
        {
            path: '/User/User',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/User/User/List.vue'),
                },
                {
                    path: 'CompanyList',
                    component: () => import('./models/User/User/CompanyList.vue'),
                },
                {
                    path: 'ProjectList',
                    component: () => import('./models/User/User/ProjectList.vue'),
                },
                {
                    path: 'EntrepreneurshipList',
                    component: () => import('./models/User/User/EntrepreneurshipList.vue'),
                },
                {
                    path: 'JoinList',
                    component: () => import('./models/User/User/JoinList.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/User/User/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/User/User/Info.vue'),
                }
            ]
        }, {
            path: '/PlatformInformation/Price',
            component: Console,
            children: [
                {
                    path: 'AdvertisementList',
                    component: () => import('./models/PlatformInformation/Price/AdvertisementList.vue'),
                },
                {
                    path: 'RecruitList',
                    component: () => import('./models/PlatformInformation/Price/RecruitList.vue'),
                },
                {
                    path: 'Recharge',
                    component: () => import('./models/PlatformInformation/Price/Recharge.vue'),
                },
                {
                    path: 'UpgradeList',
                    component: () => import('./models/PlatformInformation/Price/UpgradeList.vue'),
                },

                {
                    path: 'Form',
                    component: () => import('./models/PlatformInformation/Price/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/PlatformInformation/Price/Info.vue'),
                }
            ]
        }, {
            path: '/Sys/Dict',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Sys/Dict/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Sys/Dict/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Sys/Dict/Info.vue'),
                }
            ]
        }, {
            path: '/Sys/Feedback',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Sys/Feedback/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Sys/Feedback/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Sys/Feedback/Info.vue'),
                }
            ]
        }, {
            path: '/Sys/InvoiceList',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Sys/InvoiceList/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Sys/InvoiceList/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Sys/InvoiceList/Info.vue'),
                }
            ]
        }, {
            path: '/PlatformInformation/Proportion',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/PlatformInformation/Proportion/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/PlatformInformation/Proportion/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/PlatformInformation/Proportion/Info.vue'),
                }
            ]
        },
        {
            path: '/PlatformInformation/News',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/PlatformInformation/News/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/PlatformInformation/News/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/PlatformInformation/News/Info.vue'),
                }
            ]
        },
        {
            path: '/WithdrawalRecord/withdrawal_recode',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/WithdrawalRecord/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/WithdrawalRecord/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/WithdrawalRecord/Info.vue'),
                }
            ]
        },
        {
            path: '/Makers/MakersUser',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Makers/MakersUser/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Makers/MakersUser/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Makers/MakersUser/Info.vue'),
                }
            ]
        },
        {
            path: '/Makers/BrandAgencyFee',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Makers/BrandAgencyFee/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Makers/BrandAgencyFee/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Makers/BrandAgencyFee/Info.vue'),
                }
            ]
        },
		{
            path: '/Makers/MakersWithdrawalRecord',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Makers/MakersWithdrawalRecord/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Makers/MakersWithdrawalRecord/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Makers/MakersWithdrawalRecord/Info.vue'),
                }
            ]
        },
        {
            path: '/Makers/TransactionRecord',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Makers/TransactionRecord/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Makers/MakersWithdrawalRecord/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Makers/MakersWithdrawalRecord/Info.vue'),
                }
            ]
        },
        {
            path: '/Makers/MakerIncome',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Makers/MakerIncome/List.vue'),
                },
            ]
        },
        {
            path: '/PlatformInformation/PromoteDividends',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/PlatformInformation/PromoteDividends/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/PlatformInformation/PromoteDividends/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/PlatformInformation/PromoteDividends/Info.vue'),
                }
            ]
        },
        {
            path: '/BusinessData',
            component: Console,
            children: [
                {
                    path: 'Company',
                    component: () => import('./models/BusinessData/CompanyOperatingData.vue'),
                },
                {
                    path: 'Franchisee',
                    component: () => import('./models/BusinessData/FranchiseeBusinessData.vue'),
                },
                {
                    path: 'Platform',
                    component: () => import('./models/BusinessData/PlatformOperationData.vue'),
                }
            ]
        },
        {
            path: '/Sys/PosterMaintenance',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Sys/PosterMaintenance/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Sys/PosterMaintenance/Form.vue'),
                },
                {
                    path: 'Info',
                    component: () => import('./models/Sys/PosterMaintenance/Info.vue'),
                }
            ]
        },
        {
            path: '/Sys/PromotionSys',
            component: Console,
            children: [
                {
                    path: 'List',
                    component: () => import('./models/Sys/PromotionSys/List.vue'),
                },
                {
                    path: 'Form',
                    component: () => import('./models/Sys/PromotionSys/Form.vue'),
                }
            ]
        },
    ]
})
